import { render, staticRenderFns } from "./BaseMitNewReserveButtons.vue?vue&type=template&id=62e9a6e6&scoped=true"
import script from "./BaseMitNewReserveButtons.vue?vue&type=script&lang=js"
export * from "./BaseMitNewReserveButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e9a6e6",
  null
  
)

export default component.exports